import { SET_WAYPOINT } from "../actions/footer";

const defaultState = {
  isAboveWaypoint: true,
};

const footer = (state = defaultState, action) => {
  if (action.type === SET_WAYPOINT) {
    return {
      ...state,
      isAboveWaypoint: action.payload.isAboveWaypoint,
    };
  }
  return state;
};

export default footer;
